import * as React from "react";
import Youtube from "../assets/icons/Youtube.svg";
import Twitter from "../assets/icons/Twitter.svg";
import Facebook from "../assets/icons/Facebook.svg";
import HeaderLogo from "../assets/icons/HeaderLogo.svg";
import Instagram from "../assets/icons/Instagram.svg";
import StoneHandFooterLogo from "../assets/icons/StoneHandFooterLogo.svg";
import Rainwaterconserved from "../assets/icons/Rainwaterconserved.svg";
import ProjectsCompleted from "../assets/icons/ProjectsCompleted.svg";
import CarbonFootprint from "../assets/icons/CarbonFootprint.svg";
import NoOfStructures from "../assets/icons/NoOfStructures.svg";
import SoluProjectPlanning from "../assets/icons/SoluProjectPlanning.svg";
import SolutionDesign from "../assets/icons/SolutionDesign.svg";
import SoluModernTech from "../assets/icons/SoluModernTech.svg";
import SoluPurifying from "../assets/icons/SoluPurifying.svg";
import StructureAtRoads from "../assets/icons/StructureAtRoads.svg";
import RooftopRainwaterHar from "../assets/icons/RooftopRainwaterHar.svg";
import StructureAtBuild from "../assets/icons/StructureAtBuild.svg";
import StructureAtPark from "../assets/icons/StructureAtPark.svg";
import InfilrationTank from "../assets/icons/InfilrationTank.svg";

interface IconProps {
  src: string;
  alt: string;
  width?: string;
  height?: string;
}

const Icon: React.FC<IconProps> = ({
  src,
  alt,
  width = 200,
  height = "auto",
}) => {
  return <img src={src} alt={alt} style={{ width, height }} />;
};

const HomeLogo = () => <Icon src={HeaderLogo} alt="Header Logo" />;
const FooterLogo = () => <Icon src={StoneHandFooterLogo} alt="Footer Logo" />;
const InstagramIcon = () => <Icon src={Instagram} alt="Instagram Icon" />;
const FacebookIcon = () => <Icon src={Facebook} alt="Facebook Icon" />;
const TwitterIcon = () => <Icon src={Twitter} alt="Twitter Icon" />;
const YoutubeIcon = () => <Icon src={Youtube} alt="Twitter Icon" />;
const RainwaterconservedIcon = () => (
  <Icon
    src={Rainwaterconserved}
    alt="Youtube Icon"
    width="400px"
    height="300px"
  />
);
const ProjectsCompletedIcon = () => (
  <Icon src={ProjectsCompleted} alt="Youtube Icon" />
);
const CarbonFootprintIcon = () => (
  <Icon src={CarbonFootprint} alt="Youtube Icon" />
);
const NoOfStructuresIcon = () => (
  <Icon src={NoOfStructures} alt="No Of Structures Icon" />
);
const SoluProjectPlanIcon = () => (
  <Icon
    src={SoluProjectPlanning}
    alt="No Of Structures Icon"
    width="100px"
    height="100px"
  />
);
const SoluDesignIcon = () => (
  <Icon
    src={SolutionDesign}
    alt="No Of Structures Icon"
    width="100px"
    height="100px"
  />
);
const SoluModernTechIcon = () => (
  <Icon
    src={SoluModernTech}
    alt="No Of Structures Icon"
    width="100px"
    height="100px"
  />
);
const SoluPuriyingIcon = () => (
  <Icon
    src={SoluPurifying}
    alt="No Of Structures Icon"
    width="100px"
    height="100px"
  />
);
const StructureAtBuildIcon = () => (
  <Icon
    src={StructureAtBuild}
    alt="No Of Structures Icon"
    width="50px"
    height="50px"
  />
);
const StructureAtParkIcon = () => (
  <Icon
    src={StructureAtPark}
    alt="No Of Structures Icon"
    width="50px"
    height="50px"
  />
);
const StructureAtRoadsIcon = () => (
  <Icon
    src={StructureAtRoads}
    alt="No Of Structures Icon"
    width="50px"
    height="50px"
  />
);
const RooftopRainwaterHarIcon = () => (
  <Icon
    src={RooftopRainwaterHar}
    alt="No Of Structures Icon"
    width="50px"
    height="50px"
  />
);
const InfilrationTankIcon = () => (
  <Icon
    src={InfilrationTank}
    alt="No Of Structures Icon"
    width="50px"
    height="50px"
  />
);

export default {
  InstagramIcon,
  FacebookIcon,
  TwitterIcon,
  YoutubeIcon,
  HomeLogo,
  FooterLogo,
  RainwaterconservedIcon,
  ProjectsCompletedIcon,
  CarbonFootprintIcon,
  NoOfStructuresIcon,
  SoluDesignIcon,
  SoluModernTechIcon,
  SoluProjectPlanIcon,
  SoluPuriyingIcon,
  StructureAtBuildIcon,
  StructureAtParkIcon,
  StructureAtRoadsIcon,
  RooftopRainwaterHarIcon,
  InfilrationTankIcon,
};
